/**
 * Build shareable URLs for research (HashRouter: #/research/:id).
 */
export function getResearchPermalink(researchId) {
  if (!researchId) return "";
  if (typeof window === "undefined") return "";
  const base = `${window.location.origin}${window.location.pathname || "/"}`.replace(/\/$/, "");
  return `${base}#/research/${researchId}`;
}

function authorsLine(authors) {
  if (!authors || !authors.length) return "Unknown author";
  return authors.join(", ");
}

/**
 * APA 7–style repository / gray literature (simplified).
 */
export function citeAPA(r) {
  const a = authorsLine(r.authors);
  const year = r.year || "n.d.";
  const title = (r.title || "Untitled").trim();
  const campus = r.campus ? ` ${r.campus} campus.` : "";
  const dept = r.department ? ` ${r.department}.` : "";
  const url = getResearchPermalink(r._id);
  return `${a} (${year}). ${title}. Sultan Kudarat State University.${campus}${dept} SKSU Digital Research Hub. ${url}`;
}

/**
 * MLA 9–style (simplified).
 */
export function citeMLA(r) {
  const a = authorsLine(r.authors);
  const title = (r.title || "Untitled").trim();
  const year = r.year || "n.d.";
  const url = getResearchPermalink(r._id);
  return `${a}. "${title}." SKSU Digital Research Hub, ${year}, ${url}.`;
}

/**
 * Chicago author-date (simplified).
 */
export function citeChicago(r) {
  const a = authorsLine(r.authors);
  const year = r.year || "n.d.";
  const title = (r.title || "Untitled").trim();
  const url = getResearchPermalink(r._id);
  return `${a}. ${year}. "${title}." SKSU Digital Research Hub. ${url}.`;
}
